import axios from '@/axios/index'

// 声量趋势接口
export function getVoiceTrend(data) {
  return axios({
    url: '/api/competitive/index/trend',
    method: 'post',
    data
  })
}

// 排序表格总览指标
export function getSortLabel() {
  return axios({
    url: '/api/label/competitive/index/sort/label',
    method: 'get'
  })
}

// 产线分析列表
export function getList(data) {
  return axios({
    url: '/api/competitive/index/statistics/list',
    method: 'post',
    data
  })
}

// 产线分析总数
export function getListTotal(data) {
  return axios({
    url: '/api/competitive/index/statistics/list/total',
    method: 'post',
    data
  })
}

// 排序条形图对比指标
export function getCompetitiveSortLabel() {
  return axios({
    url: '/api/label/competitive/index/label',
    method: 'get'
  })
}

// 指标条形图接口
export function getColumnData(data) {
  return axios({
    url: '/api/competitive/brand/index',
    method: 'post',
    data
  })
}
